export { default } from "./RoleDetails";



// WEBPACK FOOTER //
// ./src/components/RoleDetails/index.ts